<template>
    <div class="p-4">
        <div>
            <div>
                ID: {{ id }}
            </div>
            <div>
                Role: {{ role }}
            </div>
        </div>
        <form ref="form">
            <InputGroup name="name" class="mb-3" label="Name" v-model="name" :fielderrors="errors" />
            <ButtonPrimary @click.prevent="updateProfile">Update</ButtonPrimary>
        </form>
        <form ref="formPassword">
            <InputGroup name="oldPassword" class="mb-3" label="Old Password" v-model="oldPassword" :fielderrors="errors" type="password" />
            <InputGroup name="newPassword" class="mb-3" label="New Password" v-model="newPassword" :fielderrors="errors" type="password"  />
            <InputGroup name="newConfirmPassword" class="mb-3" label="Confirm Password" v-model="newConfirmPassword" :fielderrors="errors" type="password"  />

            <ButtonSecondary @click.prevent="changePassword">Change Password</ButtonSecondary>
        </form>
    </div>
</template>
<script>

export default {
    components: {
        
    },

    data() {
        return {
            id: '',
            role: '',
            name: '',

            oldPassword: '',
            newPassword: '',
            newConfirmPassword: '',
        }
    },

    async mounted() {
        await this.authenticate();
        this.id = this.$root.user.id;
        this.role = this.isAdmin() ? 'Admin' : 'User';
        this.name = this.$root.user.name;
    },

    methods: {
        async retrieveData() {
            
        },

        async updateProfile() {
            this.errors = {};
            const response = await this.httpRequest('/profile', 'put', {
                data: {
                    name: this.name,
                }
            });

            if (response.result === 'success') {
                window.location.reload();
            }
        },

        async changePassword() {
            this.errors = {};

            if (this.newPassword !== this.newConfirmPassword) {
                this.errors.newConfirmPassword = 'Your password do not match';
            }

            if (Object.keys(this.errors).length > 0) {
                return;
            }

            const response = await this.httpRequest('/password/change', 'put', {
                data: {
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword,
                }
            });

            if (response.result === 'success') {
                this.$root.setMessage('Your password has been changed');
                this.$refs.formPassword.reset();
            }
        }
    }
}
</script>